
import React from 'react';
import { Anchor, Box, Text } from 'grommet';

const Link = ({infoLink}) => {
    return (
        <Box pad={{top: '6px', left: '16px'}} direction="row">
            <Anchor href={infoLink.link} label={infoLink.text} />
        </Box>
    )
}

const SectionTitle = ({title, infoLink}) => {
    return (
        <Box direction="row">
            <Text size="large" color="dark-4">{title}</Text>
            {infoLink && <Link infoLink={infoLink} />}
        </Box>

    );
}

export default SectionTitle;
